module.exports = __webpack_public_path__ + "img/insightful.aa976cfa.svg";